import React, { useEffect, useState } from "react";
import { Field, Form, Button } from "@bwevents/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import InputPassword from "../components/InputPassword";
import { Helpers } from "../services/Helpers";
import "./ResetPassword.scss";

export default function ResetPassword({ api, setAccount, messenger }) {
  const [resetPasswordParam] = useSearchParams();
  const token = resetPasswordParam.get("token");
  const email = resetPasswordParam.get("email");
  const navigate = useNavigate();
  const [password, setPassword] = useState();
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const formValid = passwordValid && passwordConfirmValid;

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, [token, navigate]);
  const getPassword = (e) => {
    setPassword(e);
  };
  const passwordIsValid = (e) => {
    setPasswordValid(e);
  };

  const getPasswordConfirm = (e) => {
    setPasswordConfirm(e);
  };
  const passwordConfirmIsValid = (e) => {
    setPasswordConfirmValid(e);
  };
  const handleLogin = () => {
    api("api/auth/token/", {
      method: "POST",
      body: {
        username: email,
        password,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: "password",
      },
    }).then(({ ok }) => {
      if (ok) {
        if (rememberMe) {
          localStorage.setItem(
            btoa("rememberUser"),
            btoa(JSON.stringify({ username: email, password })),
          );
        } else {
          localStorage.removeItem(btoa("rememberUser"));
        }

        messenger({
          severity: "success",
          detail: "Submitted successfully!.",
          life: 150000,
        });

        api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
          ({ body }) => {
            setAccount(body?.data);
            navigate("/");
          },
        );
      }
    });
  };
  const handleResetPassword = () => {
    api("api/auth/recovery/", {
      method: "POST",
      body: {
        token: token,
        email: email,
        password: password,
        password_repeat: passwordConfirm,
      },
    }).then(({ ok }) => {
      if (ok) {
        handleLogin();
      }
    });
  };

  return (
    <div className="reset-password-page">
      <div className="bw-event-container">
        <h2>Password recovery</h2>
        <p>
          We’ve sent the new password to {Helpers.emailMask(email)}. Enter it
          below to sign in.
        </p>
        <Form>
          <InputPassword
            label="Password"
            placeholder="Enter password"
            emmitValue={getPassword}
            emmitValid={passwordIsValid}
          >
            <p className="bw-event-callout">6 to 20 symbols (A-Z, a-z, 0-9)</p>
          </InputPassword>
          <InputPassword
            label="Repeat password"
            placeholder="Enter password"
            equalTo={password}
            typeConfirm={true}
            forceInvalidConfirm={password !== passwordConfirm}
            emmitValue={getPasswordConfirm}
            emmitValid={passwordConfirmIsValid}
          />
          <Field
            className="bw-event-checkbox mb-0"
            type="checkbox"
            label="Remember Me"
            value={rememberMe}
            setValue={setRememberMe}
          />
          <Button
            className="mx-auto bw-event-btn"
            label="Log in"
            onClick={handleResetPassword}
            disabled={!formValid}
          />
        </Form>
      </div>
    </div>
  );
}
